import { z } from 'zod';

export const ForgotPasswordOTPValidator = z
  .object({
    otp: z.string().min(1, {
      message: 'Please enter OTP.',
    }),
    password: z.string().min(1, {
      message: 'Please enter password.',
    }),
    confirmPassword: z.string().min(1, {
      message: 'Please enter confirm password.',
    }),
  })
  .refine((data) => data.password === data.confirmPassword, {
    path: ['confirmPassword'],
    message: 'Passwords does not match',
  });

export const ForgotPasswordValidator = z.object({
  email: z
    .string()
    .email({
      message: 'Please enter a valid email address.',
    })
    .min(1, {
      message: 'Please enter email.',
    }),
});

export type ForgotPasswordOTPFormData = z.infer<
  typeof ForgotPasswordOTPValidator
>;
export type ForgotPasswordFormData = z.infer<typeof ForgotPasswordValidator>;
